export const ERROR_MESSAGE = [
    {error:"NotEmpty", message:"この項目は必須入力です。"},
    {error:"FormatError", message:"この項目の形式が正しくありません。"},
    {error:"MinSize", message:"この項目の最小桁数を下回っています。"},
    {error:"Size", message:"この項目の桁数が正しくありません。"},
    {error:"UnusableCharacters", message:"使用できない文字が使われています"},
    {error:"Duplicate", message:"この値は既に使われています"},
    {error:"NotFound", message:"この値は異なります"},
    {error:"LockOut", message:"このアカウントは現在使用できません"}
]